// Custom drag-and-drop file upload zones
// Replaces FilePond with a lightweight, dependency-free solution

$(document).on('turbo:load', () => {
    document.querySelectorAll('.custom-file-drop').forEach(initDropZone);
});

function initDropZone(dropZone) {
    const input = dropZone.querySelector('input[type="file"]');
    if (!input) return;

    const label = dropZone.querySelector('.drop-text');
    const defaultText = label ? label.textContent : 'Drag & drop or click to browse';

    // Drag events
    ['dragenter', 'dragover'].forEach(evt => {
        dropZone.addEventListener(evt, e => {
            e.preventDefault();
            e.stopPropagation();
            dropZone.classList.add('drag-over');
        });
    });

    ['dragleave', 'drop'].forEach(evt => {
        dropZone.addEventListener(evt, e => {
            e.preventDefault();
            e.stopPropagation();
            dropZone.classList.remove('drag-over');
        });
    });

    dropZone.addEventListener('drop', e => {
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            const dt = new DataTransfer();
            dt.items.add(files[0]);
            input.files = dt.files;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });

    input.addEventListener('change', () => {
        if (input.files.length > 0) {
            updateLabel(dropZone, label, input.files[0].name);
            enableSubmitButton(dropZone);
        } else {
            resetLabel(label, defaultText);
        }
    });
}

function updateLabel(dropZone, label, fileName) {
    if (!label) return;

    const iconEl = label.querySelector('i');
    const nameSpan = label.querySelector('span') || label;

    // Build: icon + file name + remove button
    label.innerHTML = '';
    if (iconEl) {
        const successIcon = document.createElement('i');
        successIcon.className = 'bi bi-file-earmark-check me-2';
        label.appendChild(successIcon);
    }

    const textNode = document.createElement('span');
    textNode.textContent = fileName;
    label.appendChild(textNode);

    const removeBtn = document.createElement('i');
    removeBtn.className = 'bi bi-x-circle ms-2 drop-remove-btn';
    removeBtn.style.pointerEvents = 'auto';
    removeBtn.style.cursor = 'pointer';
    removeBtn.style.color = '#c0392b';
    removeBtn.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const input = dropZone.querySelector('input[type="file"]');
        input.value = '';
        const defaultText = dropZone.dataset.placeholder || 'Drag & drop or click to browse';
        resetLabel(label, defaultText, iconEl);
        disableSubmitButton(dropZone);
    });
    label.appendChild(removeBtn);

    dropZone.classList.add('has-file');
}

function resetLabel(label, defaultText, originalIcon) {
    if (!label) return;
    label.innerHTML = '';

    const icon = document.createElement('i');
    icon.className = 'bi bi-cloud-arrow-up me-2';
    label.appendChild(icon);

    const span = document.createElement('span');
    span.textContent = defaultText;
    label.appendChild(span);

    const dropZone = label.closest('.custom-file-drop');
    if (dropZone) dropZone.classList.remove('has-file');
}

function enableSubmitButton(dropZone) {
    const form = dropZone.closest('form');
    if (!form) return;
    const submitBtn = form.querySelector('[type="submit"], #submit-unscheduled-data');
    if (submitBtn && submitBtn.dataset.enableOnFile !== 'false') {
        submitBtn.disabled = false;
    }
}

function disableSubmitButton(dropZone) {
    const form = dropZone.closest('form');
    if (!form) return;
    const submitBtn = form.querySelector('#submit-unscheduled-data');
    if (submitBtn) {
        submitBtn.disabled = true;
    }
}
